document.addEventListener('DOMContentLoaded', function () {
  const formContacto = '#form-contacto'

  if ($(formContacto)[0]) {
    $(formContacto).validate({
      submitHandler: function (form, e) {
        e.stopPropagation()

        /*----------  Acciones cuando el formulario es válido por frontend  ----------*/
        $.ajax({
          type: 'POST',
          url: 'https://api.consiv.pe/api/enviar-consulta',
          data: { usuario: usuario, mensaje: mensaje },
          beforeSend: function () {
            $(document).find(loading).fadeIn()
          },
          complete: function () {
            $(document).find(loading).fadeOut()
          },
          success: function (result) {
            setTimeout(() => {
              $(document).find(respuesta).fadeOut()
            }, 1000)
          },
          error: function (xhr, status, error) {
            var err = eval('(' + xhr.responseText + ')')
            console.log(err.Message)
          },
          dataType: 'json',
        })

        return false
      },
      rules: {
        nombres: 'required',
        apellidos: 'required',
        pais: 'required',
        instituto_empresa: 'required',
        cargo: 'required',
        correo_electronico: {
          required: true,
          email: true,
        },
        prefijo_telefono: 'required',
        numero_telefono: {
          required: true,
          number: true,
          minlength: 7,
          maxlength: 9,
        },
        mensaje: 'required',
      },
      messages: {
        nombres: 'required',
        apellidos: 'required',
        pais: 'required',
        instituto_empresa: 'required',
        cargo: 'required',
        correo_electronico: {
          required: true,
          email: true,
        },
        prefijo_telefono: 'required',
        numero_telefono: {
          required: true,
          number: true,
          minlength: 7,
          maxlength: 9,
        },
        mensaje: 'required',
      },
    })
  }
})
